import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import styles from "components/Dashboard/index.module.scss";
import { getMyTasks } from "api";
import { formatDateForAPI } from "components/common/formatter";
import { TaskItem } from "components/Dashboard";


const TasksGrid = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [tasks, setTasks] = useState([]);

    const isStandaloneDashboard = location.pathname.includes("/sa/dashboard");

    const onMatterRefClick = (task) => {
        if (!task?.matterId) return;
        if (isStandaloneDashboard) {
            window.open(`/sa/casefile/${task.matterId}`, "_blank");
        } else {
            navigate(`/matters/${task.matterId}`);
        }
    };

    const fetchTasks = async () => {
        try {
            const today = formatDateForAPI(new Date());
            const response = await getMyTasks(today);
            const data = response?.data?.data || response?.data || [];
            setTasks(Array.isArray(data) ? data : []);
        } catch (error) { }
    };

    useEffect(() => {
        fetchTasks();
    }, []);

    return (
        <div className="h-100 w-100 d-flex flex-column overflow-hidden">
            <div
                className={`${styles["combo-label-font"]} fw-semibold p-3 ps-4 pb-2 flex-shrink-0`}
            >
                Tasks
            </div>

            <div className="overflow-auto flex-grow-1 m-2 mt-0 px-1" >
                {tasks.length === 0 ? (
                    <div className="text-center text-muted fs-sm pt-4">
                        No tasks due today
                    </div>
                ) : (
                    tasks.map((task, index) => (
                        <div key={task.taskId ?? index} className="mt-2">
                            {index > 0 && (
                                <div className="my-2" style={{ height: "1px", background: "#F3F3F3" }} />
                            )}
                            <TaskItem task={task} onMatterRefClick={onMatterRefClick} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default TasksGrid;
